import { render, staticRenderFns } from "./CreatePurchaseInvoice.vue?vue&type=template&id=06616dfe"
import script from "./CreatePurchaseInvoice.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports